import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import GeneralGeolocationOfEntityUpdate, {
  GeneralGeolocationOfEntityUpdateProps,
} from "./GeneralGeolocationOfEntityUpdate";

export interface OwnProps {
  updateProps: GeneralGeolocationOfEntityUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function GeneralGeolocationOfEntityUpdateModal({
  updateProps,
  ...dialogProps
}: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Update geolocation
      </AppModalTitle>

      <DialogContent>
        <Box sx={{ py: 1 }}>
          <GeneralGeolocationOfEntityUpdate {...updateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
